export function formatMs(value: number | null | undefined, empty = '—'): string {
  if (value == null || !Number.isFinite(value)) return empty
  if (value < 1000) return `${Math.round(value)}ms`
  return `${(value / 1000).toFixed(1)}s`
}
